export default {
  title: 'Gegevensverwijdering aanvragen voor {{name}}',
  description:
    'Dit maakt een AVG-verzoek tot gegevensverwijdering aan. Een beheerder moet dit goedkeuren voordat de gegevens van de klant definitief worden verwijderd.',
  form: {
    note: {
      label: 'Opmerking',
      placeholder: 'Voeg context toe voor dit verzoek (optioneel)',
    },
  },
  buttons: {
    confirm: 'Verwijdering aanvragen',
  },
  toasts: {
    success: 'Verzoek tot gegevensverwijdering aangemaakt',
    error: 'Aanmaken van verzoek tot gegevensverwijdering mislukt',
  },
};
